import { useLocalSearchParams } from 'expo-router';

import { DeferredRedirect } from '../../../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams<{ orderId: string }>();

  return <DeferredRedirect href={{ pathname: '/account/gift/confirmation/[orderId]', params }} />;
}
